import React, { useEffect } from 'react';
import { Box, Divider, Paper } from '@material-ui/core';
import { useDrawerRightDispatch } from '@archiwum/drawer-right';
import { Typography, TypographyVariants } from '@archiwum/ui/typography';
import { useStyles } from './spis-layout.styles';

type SpisSprawLayoutProps = {
  children?: React.ReactNode;
};

export const SpisSprawLayout = (props: SpisSprawLayoutProps) => {
  const { children } = props;
  const drawerDispatch = useDrawerRightDispatch();
  const classes = useStyles();

  useEffect(() => {
    return () => {
      drawerDispatch({ selected: [], data: [] });
    };
  }, []);

  return (
    <div>
      <Box>
        <Paper square elevation={0}>
          <Typography
            classes={{ root: classes.header }}
            variantType={TypographyVariants.Header2}
          >
            Spis spraw
          </Typography>
          <Divider />
        </Paper>
      </Box>
      <Box display="flex" height="100%" justifyContent="space-between">
        {children}
      </Box>
    </div>
  );
};
